import { render, staticRenderFns } from "./NewUserSetPassword.vue?vue&type=template&id=33c9e8b2&"
import script from "./NewUserSetPassword.vue?vue&type=script&lang=js&"
export * from "./NewUserSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports